import '../floorplan-tabs/floorplan-tabs.scss';
import './floorplan-tabs-multiple.scss';

import Pricelist from '../../modules/pricelist/pricelist';
import Component from '../component/component';

import './img/UV-61-position.svg';
import './img/UV-62-position.svg';
import './img/UV-63-position.svg';

export default class FloorplanTabsMultiple extends Component {

    static initSelector: string = '.floorplan-tabs--multiple';

    constructor(target: HTMLElement) {
        super(target);

        this.element.find('.floorplan-tabs').each((floorplanIndex: number, floorplanTab: HTMLElement) => {
            $(floorplanTab).find('.floorplan__overlay[data-name], .floorplan__overlay[data-id]').each((index: number, element: HTMLElement) => Pricelist.initTooltip(element));
        });
    }

}
